export default __webpack_public_path__ + "static/media/hero-image.8b88b5c0.png";